import React from 'react';
import ProfitableGoingConcern, {
  profitableGoingConcernRoutes,
} from './subrouters/ProfitableGoingConcern/router';
import UnderExternalAdministration, {
  underExternalAdministrationRoutes,
} from './subrouters/UnderExternalAdministration/router';
import EditListingSubrouter, {
  editListingSubrouterRoutes,
} from './subrouters/EditListingSubrouter';
import { Navigate } from 'react-router-dom';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';

type ListingRoute = EnhancedRouteProps & { labelId?: string };

export default [
  {
    path: 'edit',
    element: EditListingSubrouter,
    routes: editListingSubrouterRoutes,
  },
  {
    path: 'profitable-going-concern/:id',
    element: ProfitableGoingConcern,
    routes: profitableGoingConcernRoutes,
    labelId: 'profitableGoingConcern',
  },
  {
    path: 'under-external-administration/:id',
    element: UnderExternalAdministration,
    routes: underExternalAdministrationRoutes,
    labelId: 'underExternalAdministration',
  },
  {
    index: true,
    element: <Navigate to="/page-not-found" replace />,
  },
] as Array<ListingRoute>;
